/**
 * Tela de fase futura.
 *
 * Existe para que NENHUM item de menu leve a lugar nenhum. A rota é real, o
 * título é real, e o vazio diz a verdade: o que a tela vai fazer e em que fase
 * ela chega. Nada de dado de exemplo que pareça real.
 *
 * `kind="no-data"` é o correto aqui: a ausência é estrutural (não existe nada
 * cadastrado ainda), não um zero medido.
 */
import { Card, EmptyState } from '@mgdlead/ui';

import { PageHeader } from '@mgdlead/ui';
import type { WorkspaceNavItem } from '../features/workspace/navigation';

export interface PhaseScreenProps {
  item: WorkspaceNavItem;
}

export function PhaseScreen({ item }: PhaseScreenProps) {
  const phase = item.phase;

  return (
    <>
      <PageHeader title={item.label} description={item.summary} />
      <Card padded={false}>
        <EmptyState
          kind="no-data"
          icon={item.icon}
          title={phase ? `Chega na Fase ${phase.number}` : 'Ainda não disponível'}
          description={
            phase
              ? `Esta tela entrega ${phase.delivers}. Até lá o menu já existe para a navegação não mudar de lugar quando a fase entrar no ar.`
              : 'Esta tela ainda não foi construída.'
          }
        />
      </Card>
    </>
  );
}
